/**
 * Created by fers on 10.05.16.
 */

import * as IFrameEdit from './IFrameEdit.react';
import * as AddRelationEdit from './AddRelationEdit.react';
import * as JSActionEdit from './JSActionEdit.react';

let handlers = [
    IFrameEdit,
    AddRelationEdit,
    JSActionEdit
];

let handlerMap = {};

for (let handler of handlers) {
    handlerMap[handler.handlerName] = {
        value: handler.handlerName,
        handler: handler.default
    };
}

export default handlerMap;
